import React, { useState } from "react";
import { FormControl } from "react-bootstrap";
import { faMagnifyingGlass } from "../../../../../helpers/icons/fontAwesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./FeatureSearch.module.scss";

const FeatureSearch = ({ t, search }) => {
  // Local state to manage the search term
  const [input, setInput] = useState("");

  // Function to handle input change and call the search function
  const handleInputChange = (event) => {
    const value = event.target.value;
    setInput(value);
    search(value); // Call the search function with the new value
  };

  return (
    <div className={classes["feature-search-container"]}>
      <FormControl
        type="text"
        placeholder={t("search") + "..."}
        className={classes["feature-search-input"]}
        value={input}
        onChange={handleInputChange}
      />
      <span className={classes.featureSearchIcon}>
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </span>
    </div>
  );
};

export default FeatureSearch;
